import { EquipamientoViewModel, TProductoSolicitudViewModel, TwEmbalajesViewModel } from '../productos/productos.types';
import { TwSolicitudJerarquiaViewModel } from '../datosbasicos/datosbasicos.types';
import { DestinoControlViewModel } from '../../../_mantenimiento/general/destinoscontrol/destinocontrol.types';
import { TDocumentoSolicitudViewModel } from '../documentos/documentos.types';
import { TComentarioInspectorViewModel } from '../seguimiento/seguimiento.types';

export class TInspeccionViewModel {
    public IdSolicitud: number;
    public Documental: boolean | null;
    public SeEfectuaIdentidadFisica: boolean;
    public Identidad: boolean | null;
    public Fisica: boolean | null;
    public IdUsuarioDocumental: number;
    public IdUsuarioIdentidad: number;
    public IdUsuarioFisica: number;
    public IdUsuarioNoProcede: number | null;
    public Observaciones = '';
    public IdDecision: number | null;
    public FechaDocumental: Date | null;
    public FechaIdentidad: Date | null;
    public FechaFisica: Date | null;
    public FechaLlegada: Date;
    public FechaFinalizacion: Date | null;
    public IdEstadoSolicitud: number;
    public IdTipoSolicitud: number;
    public IdEstadoChedPp: number | null;
    public IdTipoPuntoInspeccion: number;
    public EsPredua: boolean;
    public EsPrevia: boolean;
    public EsReImportacion: boolean;
    public IdEstadoSolicitudDescripcion: string;
    public IdTipoSolicitudDescripcion: string;
    public IdEstadoChedPpDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public Mrn: string;
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public TSolicitudEquipamientoCollection: EquipamientoViewModel[];
    public TProductoSolicitudCollection: TProductoSolicitudViewModel[];
    public TwEmbalajesCollection: TwEmbalajesViewModel[];
    public TComentarioInspectorCollection: TComentarioInspectorViewModel[];
    public IdUsuarioDocumentalDescripcion: string;
    public IdUsuarioIdentidadDescripcion: string;
    public IdUsuarioFisicaDescripcion: string;
    public IdMedidaRechazo: number | null;
    public IdMotivoRechazo: number | null;
    public IdAlcanceRechazo: number | null;
    public IdDetalleMotivoRechazo: number | null;
    public IdElementoRechazo: number | null;
    public TwInspeccionRechazo: TwInspeccionRechazoViewModel;
    public TSolicitudMotivoRechazoCollection: TwSolicitudMotivoRechazoViewModel[];
    public TSolicitudMedidaRechazoCollection: TwSolicitudMedidaRechazoViewModel[];
    //colección de documentos traídos desde servidor - petición GET
    public DocumentosAdjuntosRechazoCollection: TDocumentoSolicitudViewModel[];
    //colección de documentos enviados a servidor - petición POST
    public DocumentosAdjuntosRechazoIdsCollection: number[];
}

export class TwInspeccionRechazoViewModel {
    public IdSolicitud: number;
    public TipoInspSupervisionPuestoInsp: boolean | null;
    public TipoInspControlSeguimientoNoSintomas: boolean | null;
    public TipoInspControlSeguimientoSiSintomas: boolean | null;
    public FechaRechazo: Date | null; //es la fecha de las medidas
    public ObservacionesRechazo: string;
    public IdDestinoControl: number | null;
    public TwDestinoControl: DestinoControlViewModel;
}

export class TwSolicitudMedidaRechazoViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdMedidaRechazo: number;
    public IdAlcanceRechazo: number;
    public IdMedidaRechazoDescripcion: string;
    public IdAlcanceRechazoDescripcion: string;
    //sólo para mostrar en el grid los productos separados por comas
    public IdProductoMedidaRechazoDescripcion = '';
    //sólo para mostrar en el grid los embalajes separados por comas
    public IdEmbalajeMedidaRechazoDescripcion = '';
    public ProductoMedidaRechazoCollection: TwProductoRechazoMedida[] = [];
    public EmbalajeMedidaRechazoCollection: TwEmbalajeRechazoMedida[] = [];
    //medida Cuarentena
    public FechaComienzoCuarentena: Date | null;
    public FechaTerminacionPrevistaCuarentena: Date | null;
    public FechaTerminacionCuarentena: Date | null;
    public IdPaisCuarentena: number | null;
    public IdPaisCuarentenaDescripcion: string;
    public LugarCuarentena: string;
}

export class TwSolicitudMotivoRechazoViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdMotivoRechazo: number;
    public IdDetalleMotivoRechazo: number;
    public IdElementoRechazo: number;
    public IdMotivoRechazoDescripcion: string;
    public IdDetalleMotivoRechazoDescripcion: string;
    public IdElementoRechazoDescripcion: string;
    //sólo para mostrar en el grid los productos separados por comas
    public IdProductoMotivoRechazoDescripcion = '';
    //sólo para mostrar en el grid los embalajes separados por comas
    public IdEmbalajeMotivoRechazoDescripcion = '';
    public ObservacionesMotivosRechazo = '';
    public IdOrganismoNocivo: number | null;
    public IdGradoContaminacion: number | null;
    public IdOrganismoNocivoNoReguladoUE: number | null;
    public IdOrganismoNocivoNoEspecie: number | null;
    public IdOrganismoNocivoDescripcion: string;
    public IdGradoContaminacionDescripcion: string;
    public IdOrganismoNocivoNoReguladoUEDescripcion: string;
    public IdOrganismoNocivoNoEspecieDescripcion: string;
    public ProductoMotivoRechazoCollection: TwProductoRechazoMotivo[] = [];
    public EmbalajeMotivoRechazoCollection: TwEmbalajeRechazoMotivo[] = [];
}

//datos producto medida rechazo
export class TwProductoRechazoMedida {
    public Id: number;
    public IdSolicitudMedidaRechazo: number;
    public IdProductoMedidaRechazo: number;
    public IdProductoMedidaRechazoDescripcion: string;
}
//datos producto motivo rechazo
export class TwProductoRechazoMotivo {
    public Id: number;
    public IdSolicitudMotivoRechazo: number;
    public IdProductoMotivoRechazo: number;
    public IdProductoMotivoRechazoDescripcion: string;
}

//datos embalaje medida rechazo
export class TwEmbalajeRechazoMedida {
    public Id: number;
    public IdSolicitudMedidaRechazo: number;
    public IdEmbalajeMedidaRechazo: number;
    public IdEmbalajeMedidaRechazoDescripcion: string;
}
//datos embalaje motivo rechazo
export class TwEmbalajeRechazoMotivo {
    public Id: number;
    public IdSolicitudMotivoRechazo: number;
    public IdEmbalajeMotivoRechazo: number;
    public IdEmbalajeMotivoRechazoDescripcion: string;
}

export class TwSolicitudFrViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdContadorFr: number;
    public Frecuencia: number;
    public PorcentajePif: number;
    public PorcentajeNacional: number;
    public TotalPif: number;
    public TotalConFisicaPif: number;
    public TotalNacional: number;
    public TotalConFisicaNacional: number;
    public GrupoFrDescripcion: string;
    //campo para uso interno en Rechazos Parciales
    public Aceptado: boolean | null = null;
}

//petición post, para enviar ePhyto con documentos adjuntos
export class InspeccionSubmitPostRequest {
    public IdSolicitud: number;
    public DocumentosAdjuntosRechazoIdsCollection: number[] = [];
}

export class TRechazoParcialSolicitudViewModel {
    public Id: number;
    public IdProducto: number | null;
    public IdEmbalaje: number | null;
    public Aceptado: boolean | null;
}

export class TwSolicitudFrSanidadExtViewModel {
    public Id: number;
    public IdSolicitud: number;
    public IdContadorFrSanidadExt: number;
    public PorcentajePifFisica: number;
    public PorcentajePifLab?: number;
    public PorcentajeNacionalFisica: number;
    public PorcentajeNacionalLab?: number;
    public PorcentajeFrecuenciaFisica: number; // El definido para el TwTcGrupoTaricFrSanidadExt
    public PorcentajeFrecuenciaLab?: number | null; // El definido para el TwTcGrupoTaricFrSanidadExt
    public TotalPif: number; // Total para Física y Laboratorio
    public TotalConFisicaPif: number;
    public TotalConLabPif?: number;
    public TotalNacional: number;
    public TotalConFisicaNacional: number;
    public TotalConLabNacional?: number;
    public TieneFisica: number;
    public TieneLab?: number;
    public Definitivo: number;
    public GrupoFrDescripcion: string;
    public CodigoTaric: string;
    public Riesgo: string;
    public PaisOrigen: string;
    //campo para uso interno en Rechazos Parciales
    public Aceptado: boolean | null = null;
}
